import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NavParams, PopoverController } from '@ionic/angular';
import { NgxSpinnerService } from 'ngx-spinner';
import { PedidosProvider } from '../../../../providers/PedidosProvider';

@Component({
    selector: 'app-edit-rent',
    templateUrl: './edit-rent.component.html',
    styleUrls: ['./edit-rent.component.scss'],
    standalone: false
})
export class EditRentComponent implements OnInit {

  public rent: any;

  rentForm = new FormGroup<any>({
    'garantia': new FormControl('', Validators.required),
    'fecha_inicio_renta': new FormControl('', Validators.required),
    'fecha_fin_renta': new FormControl('', Validators.required)
  });

  constructor(
    private navParams: NavParams,
    private popoverController: PopoverController,
    private pedidosProvider: PedidosProvider,
    private spinner: NgxSpinnerService,
  ) { }

  ngOnInit() {
    this.rent = this.navParams.data.rent;
    if (this.rent) {
      let startDate = this.rent.fecha_inicio_renta.split(' ')[0];
      let endDate = this.rent.fecha_fin_renta.split(' ')[0];
      this.rentForm.controls.garantia.setValue(
        this.rent.garantia
      );
      this.rentForm.controls.fecha_inicio_renta.setValue(
        startDate
      );
      this.rentForm.controls.fecha_fin_renta.setValue(
        endDate
      );
    }
  }

  onCancel() {
    this.popoverController.dismiss(null);
  }

  onSubmit() {
    if (this.rentForm.valid) {
      const params = {
        id: this.rent.id,
        garantia: this.rentForm.controls.garantia.value,
        fecha_inicio_renta: this.rentForm.controls.fecha_inicio_renta.value,
        fecha_fin_renta: this.rentForm.controls.fecha_fin_renta.value,
      };
      this.spinner.show();
      this.pedidosProvider.updateRent(params).then(response => {
        this.spinner.hide();
        if (response.data) {
          this.popoverController.dismiss({success: true});
        }
      }, error => {
        this.spinner.hide();
      });
    }
  }

}
